export default __webpack_public_path__ + "static/media/Syzmik21Catalogue-400x482.050a7e88.jpg";